import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateClientSettings, queueClientSettingsUpdate, setLocalClientSettings } from 'state/auth/actions'

export const useClientSettings = (key: string) => {
  const dispatch = useDispatch()
// @ts-expect-error - TS18046 - 'state' is of type 'unknown'.
  const clientSettings = useSelector((state) => state.auth?.clientSettings) || {}

  const updateSettings = useCallback(
    <T>(value: T) => dispatch(updateClientSettings({ key, value })),
    [key]
  )

  // queued to run inside `onAuthenticated`
  const queueSettingsUpdate = useCallback(
    <T>(value: T) => {
      // Optimistically update local Redux state so the UI sees it now
      dispatch(setLocalClientSettings({ key, value }))

      // Queue the real server update for onAuthenticated
      dispatch(queueClientSettingsUpdate({ key, value }))
    },
    [dispatch, key],
  )

  return {
    value: clientSettings[key],
    allSettings: clientSettings,
    updateSettings,
    queueSettingsUpdate,
  }
}

export default useClientSettings
